const CONFIG = {
    'backendUrl': 'http://localhost:3000'
};

module.exports = CONFIG;
